import { render, staticRenderFns } from "./FormFeedback.vue?vue&type=template&id=6b07e27f&scoped=true&"
import script from "./FormFeedback.vue?vue&type=script&lang=js&"
export * from "./FormFeedback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b07e27f",
  null
  
)

export default component.exports